export default __webpack_public_path__ + "static/media/home_banner_1.5b8d9df9.jpg";